module.exports = __webpack_public_path__ + "assets/webgl/Assets_1_base_color.jpg.dxt.e8bb738a.ktx";